import Vue from "vue";

import { BootstrapVue} from "bootstrap-vue/dist/bootstrap-vue.esm";
Vue.use(BootstrapVue);

import Notifications from 'vue-notification'
Vue.use(Notifications);

import App from "./";

new Vue({
render: (h) => h(App),
}).$mount("#app");